/* tslint:disable */
/* eslint-disable */
/* @relayHash 21432009c575d46f176e8724cdf1fd9c */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Page = {
    offset?: number | null;
    limit?: number | null;
};
export type BackgroundCheckFilter = {
    companyUUID?: string | null;
    searchText?: string | null;
    approved?: boolean | null;
    applicationWaiting?: boolean | null;
    responsesWaiting?: boolean | null;
    approvalWaiting?: boolean | null;
};
export type App_BackgroundChecks_QueryVariables = {
    page?: Page | null;
    filter?: BackgroundCheckFilter | null;
};
export type App_BackgroundChecks_QueryResponse = {
    readonly backgroundChecks: {
        readonly " $fragmentRefs": FragmentRefs<"BackgroundChecks_backgroundChecks">;
    };
};
export type App_BackgroundChecks_Query = {
    readonly response: App_BackgroundChecks_QueryResponse;
    readonly variables: App_BackgroundChecks_QueryVariables;
};



/*
query App_BackgroundChecks_Query(
  $page: Page
  $filter: BackgroundCheckFilter
) {
  backgroundChecks(page: $page, filter: $filter) {
    ...BackgroundChecks_backgroundChecks
  }
}

fragment BackgroundChecks_backgroundChecks on BackgroundCheckPage {
  edges {
    uuid
    delegate {
      uuid
      firstName
      lastName
      email
      profileImageUrl
    }
    approvalDate
    applicationSentAt
    applicationReceivedAt
    hasAllResponses
    requestedDBS
    onlyDBS
    isRenewal
    isVerification
    idExpiryDate
    dbsExpiryDate
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Page",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "BackgroundCheckFilter",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_BackgroundChecks_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "backgroundChecks",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "BackgroundCheckPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "BackgroundChecks_backgroundChecks",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_BackgroundChecks_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "backgroundChecks",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "BackgroundCheckPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "delegate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Delegate",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "email",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "profileImageUrl",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "approvalDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationSentAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationReceivedAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasAllResponses",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "requestedDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "onlyDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRenewal",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isVerification",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "idExpiryDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsExpiryDate",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_BackgroundChecks_Query",
            "id": null,
            "text": "query App_BackgroundChecks_Query(\n  $page: Page\n  $filter: BackgroundCheckFilter\n) {\n  backgroundChecks(page: $page, filter: $filter) {\n    ...BackgroundChecks_backgroundChecks\n  }\n}\n\nfragment BackgroundChecks_backgroundChecks on BackgroundCheckPage {\n  edges {\n    uuid\n    delegate {\n      uuid\n      firstName\n      lastName\n      email\n      profileImageUrl\n    }\n    approvalDate\n    applicationSentAt\n    applicationReceivedAt\n    hasAllResponses\n    requestedDBS\n    onlyDBS\n    isRenewal\n    isVerification\n    idExpiryDate\n    dbsExpiryDate\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '800e1b99eb850a5d736f2fa9c786b5c9';
export default node;
